module.exports = __webpack_public_path__ + "static/img/goodness2.f5ad3bb5.png";